import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _typeof from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/typeof";

/* eslint-disable */
// @ts-nocheck
var STORAGE_USER_KEY = 'STORAGE_USER_KEY'; // const STORAGE_CARTLIST_KEY = 'STORAGE_CARTLIST_KEY'
// const STORAGE_QUERYMYLIST_KEY = 'STORAGE_QUERYMYLIST_KEY'
// import { Toast } from 'mint-ui';

import axios from 'axios';
var prefix = 'http://testapi.gu-dao.cn'; // import authService from '@/api/authService.js'
//定义一些常量

var x_PI = 3.14159265358979324 * 3000.0 / 180.0;
var PI = 3.1415926535897932384626;
var a = 6378245.0;
var ee = 0.00669342162296594323;
export default {
  // 获取
  getLocal: function getLocal() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STORAGE_USER_KEY;
    // console.log('get local operation')
    return JSON.parse(window.localStorage.getItem(key));
  },
  // 设置用

  /**
   * @param {any} res
   */
  setLocal: function setLocal(res) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : STORAGE_USER_KEY;
    var isSaveOldData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    //第三个参数是true的话,会增加数据而不是重新设置,res必须是数组
    if (isSaveOldData) {
      if (this.getLocal(key)) {
        var oldData = this.getLocal(key);
        return window.localStorage.setItem(key, JSON.stringify(oldData.concat(res)));
      }
    }

    return window.localStorage.setItem(key, JSON.stringify(res));
  },

  /**
   * @param {any[]} obj
   */
  deepClone: function deepClone(obj) {
    var o;

    if (_typeof(obj) == "object") {
      if (obj === null) {
        o = null;
      } else {
        if (obj instanceof Array) {
          o = [];

          for (var i = 0, len = obj.length; i < len; i++) {
            o.push(this.deepClone(obj[i]));
          }
        } else {
          o = {};

          for (var j in obj) {
            o[j] = this.deepClone(obj[j]);
          }
        }
      }
    } else {
      o = obj;
    }

    return o;
  },
  getGuid: function getGuid() {
    function S4() {
      return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
    }

    return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
  },
  getGuidNew: function getGuidNew() {
    function S4() {
      return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
    }

    return S4();
  },

  /**
   * @param {string} value
   */
  isEmpty: function isEmpty(value) {
    var result = false;

    if (value == null || value == undefined) {
      result = true;
    }

    if (typeof value == 'string' && (value.replace(/\s+/g, "") == "" || value == "")) {
      result = true;
    }

    if (_typeof(value) == "object" && value instanceof Array && value.length === 0) {
      result = true;
    }

    return result;
  },

  /**
   * @param {any} time
   */
  formatTime: function formatTime(time) {
    //   格式：yyyy-MM-dd hh:mm:ss
    var date = new Date(Number(time));
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
    var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
    var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
  },

  /**
   * @param {any} time
   */
  formatDate: function formatDate(time) {
    //   格式：yyyy-MM-dd
    var date = new Date(Number(time));
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
    return Y + M + D;
  },

  /**
    * 字符串转数组
    * @param {*} value
    * @returns
    */
  stringToArray: function stringToArray(value) {
    if (this.isEmpty(value)) return [];
    if (typeof value !== 'string') return [];
    if (value.indexOf(",") < 0) return [value];
    var array = value.split(",");
    return array;
  },

  /**
   * 数组转字符串
   * @param {*} value
   * @returns
   */
  arrayToString: function arrayToString(value) {
    if (_typeof(value) == "object" && value instanceof Array) {
      if (value.length == 0) return "";
      var str = '';
      value.forEach(function (element) {
        str += element + ',';
      });
      return str.substr(0, str.length - 1);
    } else {
      return "";
    }
  },

  /**
   * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
   * 即谷歌、高德 转 百度
   * @param {number} lng
   * @param {number} lat
   * @returns {*[]}
   */
  gcj02tobd09: function gcj02tobd09(lng, lat) {
    var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
    var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
    var bd_lng = z * Math.cos(theta) + 0.0065;
    var bd_lat = z * Math.sin(theta) + 0.006;
    return [bd_lng, bd_lat];
  },

  /**
   * @param {string} value
   */
  isPhone: function isPhone(value) {
    var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;

    if (!myreg.test(value)) {
      return false;
    } else {
      return true;
    }
  },

  /**
   * @param {string} value
   */
  isIDCardNo: function isIDCardNo(value) {
    var myreg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;

    if (!myreg.test(value)) {
      return false;
    } else {
      return true;
    }
  }
};